module.exports = __webpack_public_path__ + "img/kabuki.d5b89be6.jpg";